import { render, staticRenderFns } from "./myContract.vue?vue&type=template&id=ffa0f2e6&scoped=true"
import script from "./myContract.vue?vue&type=script&lang=js"
export * from "./myContract.vue?vue&type=script&lang=js"
import style0 from "./myContract.vue?vue&type=style&index=0&id=ffa0f2e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa0f2e6",
  null
  
)

export default component.exports